var React = require('react');

function Maintenance (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Ship Maintenance Array"),React.createElement("path",{"id":"path4015-1","className":"cls-1","d":"M93.89,108.83l14.94-14.94V34.11L93.89,19.17H34.11L19.17,34.11V93.89l14.94,14.94","key":2}),React.createElement("path",{"id":"path3685-7-4-0","className":"cls-1","d":"M46.67,108.83,64,91.5l17.33,17.33","key":3})]);
}

Maintenance.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Maintenance;

Maintenance.default = Maintenance;
